export default __webpack_public_path__ + "static/media/customer-satisfaction.1311d13b.png";